import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventConfig, getEventConfig } from '../../constants/event-config';
import {
  EventRegistrationService,
  OrderSummary,
} from '../../services/event-registration.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-event-registration',
  templateUrl: './event-registration.component.html',
  styleUrls: ['./event-registration.component.scss'],
})
export class EventRegistrationComponent implements OnInit {
  event: any = null;
  name: string;
  eventConfig: EventConfig | null;
  orderSummary$: Observable<OrderSummary | null>;

  constructor(
    private route: ActivatedRoute,
    public eventRegistrationService: EventRegistrationService
  ) {}

  ngOnInit(): void {
    this.orderSummary$ = this.eventRegistrationService.orderSummary$;
    this.event = this.route.snapshot.data['event'];
    this.eventConfig = getEventConfig(this.event.event_id);
  }
}
